export const convertNauticalMilesToKm = (nauticalMiles: number) =>
  nauticalMiles * 1.852;

export const convertKmToNauticalMiles = (km: number) => km / 1.852;

export const nearlyEquals = (a: number, b: number, epsilon = 0.001) =>
  Math.abs(a - b) < epsilon;
